/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-useless-fragment */
import { selectBusiness } from '@pages/profile/store/selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ErrorRetry from '../../components/common/ErrorRetry';
import CardSkeleton from '../../components/common/Skeleton/CardSkeleton';
import { useAppDispatch } from '../../store';
import { selectBalanceState } from '../balance/store/selectors';
import { selectCombinedBalanceState } from '../combined_balance/selectors';
import { selectCurrenciesExchangeState } from '../rate/currencies/selectors';
import { fetchExchangeCurrencies } from '../rate/currencies/store';
import { selectWalletsState } from './selectors';

interface WalletInitializerProps {
  children: React.ReactNode;
  setBalance?: (balance: number | null) => void;
}

const WalletInitializer = ({
  children,
  setBalance,
}: WalletInitializerProps) => {
  const dispatch = useAppDispatch();
  const company = useSelector(selectBusiness);
  const currenciesExchange = useSelector(selectCurrenciesExchangeState);
  const walletsState = useSelector(selectWalletsState);
  const walletCombineBalanceState = useSelector(selectCombinedBalanceState);
  const balance = useSelector(selectBalanceState);

  useEffect(() => {
    if (balance.data && !currenciesExchange.data) {
      dispatch(fetchExchangeCurrencies(company?.enterpriseId || '0'));
    }
  }, [balance, currenciesExchange.data, dispatch]);

  useEffect(() => {
    if (walletCombineBalanceState.data?.combinedBalance) {
      setBalance?.(walletCombineBalanceState.data.combinedBalance);
    } else {
      setBalance?.(null);
    }
  }, [walletCombineBalanceState]);

  if (
    currenciesExchange.loading &&
    walletsState.loading &&
    balance.loading &&
    walletCombineBalanceState.loading
  ) {
    return <CardSkeleton />;
  }

  if (currenciesExchange.error) {
    return <ErrorRetry />;
  }

  return <>{children}</>;
};

export default WalletInitializer;
